export const CUSTOMER_NOT_FOUND_ERROR = "customer not found";

export const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info"
} as const;

export type TOAST_TYPES = (typeof TOAST_TYPES)[keyof typeof TOAST_TYPES];

export const TOAST_TYPE_ICONS = {
  success: "check-circle",
  error: "exclamation-triangle",
  warning: "info-circle",
  info: "info-circle"
} as const;
